module.exports = __webpack_public_path__ + "static/gallery22-0bf89e5dc07c3f2e489a6a485048ca1b.jpg";